import { useCallback } from 'react';

import { useProductFormStore } from '../store/productFormStore';

export const useBasicInfo = () => {
  const {
    formData,
    setTitle,
    setDescription,
    setSKU,
    setHsCode,
    setThumbnails,
  } = useProductFormStore();

  const handleTitleChange = useCallback(
    (title: string) => {
      setTitle(title);
    },
    [setTitle],
  );

  const handleDescriptionChange = useCallback(
    (description: string) => {
      setDescription(description);
    },
    [setDescription],
  );

  const handleSKUChange = useCallback(
    (SKU: string) => {
      setSKU(SKU);
    },
    [setSKU],
  );

  const handleHsCodeChange = useCallback(
    (hsCode: string) => {
      setHsCode(hsCode);
    },
    [setHsCode],
  );

  const handleThumbnailsChange = useCallback(
    (thumbnailUrlArray: string[]) => {
      setThumbnails(thumbnailUrlArray);
    },
    [setThumbnails],
  );

  return {
    basicInfo: formData.basicInfo,
    handleTitleChange,
    handleDescriptionChange,
    handleSKUChange,
    handleHsCodeChange,
    handleThumbnailsChange,
  };
};
